<div class="container">
  <mat-card>
    <form [formGroup]="bulkLoanForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
            <mat-select required formControlName="officeId" (selectionChange)="getOffice($event.value)">
              @for (office of offices; track office) {
                <mat-option [value]="office.id">
                  {{ office.name }}
                </mat-option>
              }
            </mat-select>
            @if (bulkLoanForm.controls.officeId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Office' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-48" (click)="assignmentDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Assignment Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="assignmentDatePicker"
              required
              formControlName="assignmentDate"
              placeholder="{{ 'labels.inputs.Assignment Date' | translate }}"
            />
            <mat-datepicker-toggle matSuffix [for]="assignmentDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #assignmentDatePicker></mat-datepicker>
            @if (bulkLoanForm.controls.assignmentDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Assignment Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="layout-row-wrap gap-2px responsive-column">
          @if (fromLoanOfficers !== undefined) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.From loan officer' | translate }}</mat-label>
              <mat-select
                required
                formControlName="fromLoanOfficerId"
                (selectionChange)="getFromOfficers($event.value)"
              >
                @for (fromOfficers of fromLoanOfficers; track fromOfficers) {
                  <mat-option [value]="fromOfficers.id">
                    {{ fromOfficers.displayName }}
                  </mat-option>
                }
              </mat-select>
              @if (bulkLoanForm.controls.fromLoanOfficerId.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.From Loan Officer' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }
        </div>

        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.To loan officer' | translate }}</mat-label>
            <mat-select required formControlName="toLoanOfficerId">
              @for (toOfficers of toLoanOfficers; track toOfficers) {
                <mat-option [value]="toOfficers.id">
                  {{ toOfficers.displayName }}
                </mat-option>
              }
            </mat-select>
            @if (bulkLoanForm.controls.toLoanOfficerId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.To Loan Officer' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="layout-row-wrap gap-2px responsive-column">
          @if (officerTemplate !== undefined) {
            <table class="flex-48">
              <thead>
                <th>{{ 'labels.inputs.Clients' | translate }}</th>
              </thead>
              <tbody>
                @for (clients of officerTemplate.accountSummaryCollection.clients; track clients) {
                  <tr>
                    <table>
                      <tr>
                        <td>
                          <strong> {{ clients.displayName }} </strong>
                        </td>
                      </tr>
                      @for (loans of clients.loans; track loans) {
                        <tr>
                          <td>
                            <mat-checkbox (change)="getLoans($event, loans.id)"
                              >{{ loans.productName }}({{ loans.accountNo }})</mat-checkbox
                            >
                          </td>
                        </tr>
                      }
                    </table>
                  </tr>
                }
              </tbody>
            </table>
          }

          @if (officerTemplate !== undefined) {
            <table class="flex-48">
              <thead>
                <th>{{ 'labels.inputs.Groups' | translate }}</th>
              </thead>
              <tbody>
                @for (groups of officerTemplate.accountSummaryCollection.groups; track groups) {
                  <tr>
                    <table>
                      <tr>
                        <td>
                          <strong> {{ groups.displayName }} </strong>
                        </td>
                      </tr>
                      @for (loans of groups.loans; track loans) {
                        <tr>
                          <td>
                            <mat-checkbox (change)="getLoans($event, loans.id)"
                              >{{ loans.productName }}({{ loans.accountNo }})</mat-checkbox
                            >
                          </td>
                        </tr>
                      }
                    </table>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          type="submit"
          mat-raised-button
          color="primary"
          [disabled]="!bulkLoanForm.valid"
          *LOSxHasPermission="'BULKREASSIGN_LOAN'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
